<div class="container" *ngIf="commPreferenceForm">
  <h1 class="sr-only">{{pageLabels?.['editCommPreferences.tag_name']}}</h1>
  <!--Account Info redirect to dashboard page-->
  <div class="acc-info-btn">
    <gds-utility-action
      [data]="{
            icon: {
            iconName: 'left-arrow-v2'
            },
            label: pageLabels?.['address.backCTA'],
            type: 'left-arrow-v2',
            disabled: false
            }"
      (click)="bacToAccInfo()"
    ></gds-utility-action>
  </div>
  <gds-spacer classes="spacer-70"></gds-spacer>
  <!--Address heading-->
  <gds-heading
    [data]="{
      heading: pageLabels?.['accountInfo.communicationPreferences']
    }"
    class="A3-W6"
  >
  </gds-heading>
  <!--Address description-->

  <ng-container>
    <gds-spacer classes="spacer-70"></gds-spacer>
    <!--Address list card-->
    <gds-body
      [data]="{
        description: pageLabels?.['editCommPreferences.description']
      }"
      class="B1-W3"
    ></gds-body>
    <gds-spacer classes="spacer-50"></gds-spacer>
    <div [formGroup]="commPreferenceForm">
      <gds-input
        ngDefaultControl
        id="orlando"
        class="checkbox-label"
        [data]="{
          primaryLabel: pageLabels?.['accountInfo.universalOrlando'],
          primaryIconTitleText: pageLabels?.['accountInfo.universalOrlando'],
          type: 'checkbox',
          altText: pageLabels?.['editCommPreferences.checkboxAltText'],
          ariaText: pageLabels?.['editCommPreferences.checkboxAltText'],
          required: true
        }"
        (valueChange)="onPrimaryClick($event)"
        [value]="uor_promos ? 'checked' : ''"
      >
      </gds-input>
      <gds-spacer classes="spacer-50"></gds-spacer>
      <gds-input
        ngDefaultControl
        id="hollywood"
        class="checkbox-label"
        [data]="{
          primaryLabel: pageLabels?.['accountInfo.universalHollywood'],
          primaryIconTitleText: pageLabels?.['accountInfo.universalHollywood'],
          type: 'checkbox',
          altText: pageLabels?.['editCommPreferences.checkboxAltText'],
          ariaText: pageLabels?.['editCommPreferences.checkboxAltText'],
          required: true
        }"
        (valueChange)="onPrimaryClick($event)"
        [value]="ush_promos ? 'checked' : ''"
      >
      </gds-input>
      <gds-spacer classes="spacer-50"></gds-spacer>
      <gds-input
        ngDefaultControl
        id="unleashed"
        class="checkbox-label"
        [data]="{
        primaryLabel: pageLabels?.['accountInfo.universalUnleashed'],
        primaryIconTitleText: pageLabels?.['accountInfo.universalUnleashed'],
        type: 'checkbox',
        altText: pageLabels?.['editCommPreferences.checkboxAltText'],
        ariaText: pageLabels?.['editCommPreferences.checkboxAltText'],
        required: true
      }"
        (valueChange)="onPrimaryClick($event)"
        [value]="uhu_promos ? 'checked' : ''"
      >
      </gds-input>
    </div>
  </ng-container>
  <gds-spacer classes="spacer-70"></gds-spacer>
  <!--Address list addCTA navigate to add-address page-->
  <gds-sticky-nav-footer
    [data]="{
      button: {
        type: 'primary',
        href: '',
        label: pageLabels?.['addAddress.save'],
        disabled: inputChanged ? 'false' : 'true',
        target: ''
      }
    }"
    (buttonClicked)="saveChanges()"
  >
  </gds-sticky-nav-footer>
  <gds-spacer classes="spacer-70"></gds-spacer>
</div>
